module.exports = __webpack_public_path__ + "img/packages/l6.3bd968.png";